// utils/battleNotifications.js (UPDATED)
import { toast } from "react-toastify";

/**
 * Show notification based on battle event
 * @param {object} event - The battle event
 * @param {number|string|null} currentUserId - The logged-in user's ID
 */
export const showBattleNotification = (event, currentUserId = null) => {
  if (!event || !event.type) {
    console.warn("⚠️ Invalid event for notification:", event);
    return;
  }

  const { type, data } = event;

  switch (type) {
    // ✅ Second player joined
    case "second_player_joined":
      const playerName =
        data?.player?.username ||
        data?.player?.name ||
        data?.username ||
        "Player";
      break;

    // ✅ Battle started — ONLY show to the creator
    case "started":
      const creatorId = data?.creator_id;
      // If we have both IDs, only notify the creator
      if (currentUserId === event?.creator_id ) {

      toast.success("⚔️ Battle has started!", {
        autoClose: 3000,
        position: "top-center",
      });
    }
      break;

    // ✅ Tick event (round progress)
    case "tick":
      const currentRound = data?.current_round || data?.round || "";
      const totalRounds = data?.total_rounds || "";
      if (currentRound && totalRounds) {
        toast.info(`🎯 Round ${currentRound}/${totalRounds}`, {
          autoClose: 2000,
          position: "bottom-right",
        });
      }
      break;

    // ✅ Flip event (box opened)
    case "flip":
      break;

    // ✅ Battle ended
    case "ended":
      break;

    // ✅ Player left
    case "player_left":
      const leftPlayer =
        data?.player?.username || data?.player?.name || "A player";
      toast.warn(`👋 ${leftPlayer} left the battle`, {
        autoClose: 3000,
        position: "top-right",
      });
      break;

    // ✅ Battle cancelled
    case "cancelled":
      toast.error("❌ Battle was cancelled", {
        autoClose: 3000,
        position: "top-center",
      });
      break;

    default:
      break;
  }
};

/**
 * Show connection status notification
 */
export const showConnectionNotification = (isConnected) => {
  if (isConnected) {
    toast.success("🟢 Connected to battle server", {
      position: "bottom-right",
      autoClose: 2000,
    });
  } else {
    toast.error("🔴 Disconnected from battle server", {
      position: "bottom-right",
      autoClose: 3000,
    });
  }
};
